<template>
	<div class="home" id="home">
		<carousel/>
	</div>
</template>

<script>
	import carousel from './carousel'

	export default {
		components:{
			carousel
		},
		methods:{
			
		}
	}	
</script>

<style lang='scss' scoped>

</style>